/**
 * @param {string} password
 * @param {string} passwordConfirm
 */
export const validatePassword = (password, passwordConfirm) => {
  let errorMessage;
  let errorMessage_ = "Password should ";
  if (password?.toString() !== passwordConfirm?.toString()) {
    return (errorMessage = {
      error: true,
      msg: "Password and confirmation do not match",
    });
  }
  if (String(password)?.length < 8) {
    return (errorMessage = {
      error: true,
      msg: "Password must be at least 8 characters",
    });
  }
  if (!(/[A-Z]/.test(password) && /[a-z]/.test(password))) {
    errorMessage_ += "contain at least 1 upper and lowercase character";
  }
  if (!/[0-9]/.test(password)) {
    if (errorMessage_.substring(-1) !== " ") {
      errorMessage_ += ", ";
    }
    errorMessage_ += "contain a minimum of 1 numeric character";
  }
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if (!specialChars.test(password)) {
    if (errorMessage_.substring(-1) !== " ") {
      errorMessage_ += ", ";
    }
    errorMessage_ += "contain a minimum of 1 special character";
  }

  if (errorMessage_ === "Password should ") {
    return null;
  }

  return (errorMessage = {
    error: true,
    msg: errorMessage_ + ".",
  });
};
